(() => {
  if (customElements.get('bb-sku-filter')) return;
  const colors={'01':['Antrasit','#4b4d50'],'02':['Bej','#d9c8a9'],'03':['Beyaz','#fff'],'04':['Bordo','#731f2c'],'05':['Camel','#b98555'],'06':['Eflatun','#ad77c5'],'07':['Fuşya','#dc217f'],'08':['Glow','#d8ff38'],'09':['Gri','#909399'],'10':['Haki','#68704a'],'11':['Hardal','#c69b22'],'12':['Kahve','#6f4d36'],'13':['Kamuflaj','linear-gradient(135deg,#4e5536 0 33%,#8b7950 33% 66%,#313a28 66%)'],'14':['Kırmızı','#c62828'],'15':['Kiremit','#a84e36'],'16':['Krem','#eee3c7'],'17':['Lacivert','#152d55'],'18':['Lila','#b9a1da'],'19':['Mavi','#2768b2'],'20':['Mavi Buz','#b7dce8'],'21':['Mavi Petrol','#12647a'],'22':['Mor','#633b82'],'23':['Mürdüm','#6c294f'],'24':['Neon','#caff00'],'25':['Pembe','#e88eb4'],'26':['Pembe Toz','#d8a8ad'],'27':['Petrol','#167376'],'28':['Sarı','#f2cc26'],'29':['Siyah','#111'],'30':['Somon','#e98c78'],'31':['Toprak','#8c5b3e'],'32':['Turkuaz','#28b7b2'],'33':['Turuncu','#ed7d25'],'34':['Vizon','#9a8170'],'35':['Yeşil','#397447'],'36':['Yeşil Çimen','#65a844'],'37':['Yeşil Petrol','#22675e'],'38':['Off White','#f5f1e7']};
  const families={'1':'Bench','2':'Bere','3':'Beyzbol','4':'Bucket','5':'Hip Hop','6':'B-Shirt','7':'Trucker','8':'Docker'};
  colors.multi=['Çok renkli','conic-gradient(#c62828,#f2cc26,#397447,#2768b2,#c62828)'];
  const benchCategories=['Çocuk','Dizi / Film','Harfler ve Rakamlar','Hayvanlar','Karma','Meslekler','Oyun','Sloganlar','Spor'];
  const gameCategories={'01':'Dizi','02':'Film','03':'Hayvanlar','04':'Ülkeler','05':'Tarihi Kişilikler','06':'Yemekler','07':'Meslekler','08':'Spor','09':'Oyun','10':'Dünya Kupası'};
  const benchColors={'1':'03','2':'05','3':'08','4':'10','5':'14','6':'25','7':'28','8':'29','9':'multi','N':'24'};
  const facets={kind:'kinds',model:'models',color:'colors',age:'ages',series:'series',fit:'fits',size:'sizes',category:'categories',version:'versions'};
  const childCodes=new Set(['2420','3400','5400','5410','7410']);
  const adultCodes=new Set(['2100','2500','2700','3200','3500','3510','3600','3610','4500','5500','7100','7200','7500','8000']);
  const seriesCodes={'2100':'Classic','2500':'Premium','3200':'Cordura','3500':'Premium','3510':'Premium','4500':'Premium','5500':'Premium','7100':'Classic','7200':'Cordura','7500':'Premium'};
  // Exact legacy records confirmed by the merchant on 2026-09-11. No SKU rewriting.
  const confirmedVariantFacts={'6000-03':{size:'M-L'},'8683295077630':{age:'Yetişkin'},'8684975817478':{age:'Yetişkin'}};
  const wearableModels=new Set(['Bere','Beyzbol','Six','Vintage','Bucket','Hip Hop','B-Shirt','Trucker','Docker','Şapka']);
  const normalize=text=>String(text||'').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i');
  function benchKind(models){return models.has('Bere')?"Bench'li Bere":models.has('B-Shirt')?"Bench'li B-Shirt":"Bench'li Şapka"}
  function sizeValue(value){
    const text=String(value||'').trim().toUpperCase().replace(/[–—/]/g,'-').replace(/\s*-\s*/g,'-').replace(/\s+/g,' ');
    if(/^(?:STD|STANDART|STANDARD|ONE SIZE|TEK BEDEN)$/.test(text))return 'Tek beden';
    const token='(?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL)';
    if(new RegExp('^'+token+'(?:-'+token+')?$').test(text))return text.replace(/XXXL/g,'3XL').replace(/XXL/g,'2XL');
    if(/^\d{2}(?:-\d{2})?(?: CM)?$/.test(text))return text;
    return null;
  }
  function compareOptions(type,a,b){
    if(type==='size'){
      const sizes=['XXXS','XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','Tek beden'];
      const rank=value=>{const i=sizes.indexOf(value.split('-')[0]);return i<0?sizes.length:i};
      return rank(a)-rank(b)||a.localeCompare(b,'tr',{numeric:true});
    }
    return a.localeCompare(b,'tr');
  }
  function productKey(value){
    try{return decodeURIComponent(String(value)).normalize('NFC')}
    catch{return String(value).normalize('NFC')}
  }
  function parseSku(sku) {
    const result=Object.fromEntries(Object.values(facets).map(key=>[key,new Set()]));
    const value=String(sku||'').trim().toUpperCase();
    const base=/^(?:([AB])-)?([1-8]\d{3})-((?:\d{2}){1,3})(?=$|[-_\s])/.exec(value);
    let bench=value;
    if(base){
      // Six and Vintage are separate storefront models, including their Bench sets.
      result.models.add(base[2]==='3510'?'Six':['3600','3610'].includes(base[2])?'Vintage':base[2]==='5410'?'Trucker':families[base[2][0]]);
      if(childCodes.has(base[2]))result.ages.add('Çocuk');
      else if(adultCodes.has(base[2]))result.ages.add('Yetişkin');
      if(seriesCodes[base[2]])result.series.add(seriesCodes[base[2]]);
      if(base[2]==='2700')result.fits.add('XL');
      else if(['2100','2500'].includes(base[2]))result.fits.add('Standart');
      for(const color of base[3].match(/\d{2}/g)||[])if(colors[color])result.colors.add(color);
      if(base[2]==='1000'&&base[1]&&base[0]===value)result.versions.add(base[1]==='A'?'V1':'V2');
      // Only A/B system products can carry a Bench suffix. Bare embroidered caps cannot.
      bench=base[1]?value.slice(base[0].length).replace(/^-/,''):'';
    }
    const standard=/^([12])([0-8])-\d{3}-([1-9N]{3})$/.exec(bench);
    const game=/^BG(0[1-9]|10)-(?:\d{3}-([1-9N]{3})|\d+)$/.exec(bench);
    const collection=/^C-\d{4}-([1-9N]{3})$/.exec(bench);
    const singleBench=standard||collection||(game&&game[2]);
    const benchPack=game&&!game[2];
    const broadPack=/^(?:BGSET|BGMAX|PACK)-[A-Z0-9]+(?:-[A-Z0-9]+)*$/.test(value);
    let palette;
    if(standard){
      result.categories.add(benchCategories[Number(standard[2])]);
      // This is the Bench's version, including preserved historical mismatched sets.
      result.versions.add('V'+standard[1]);palette=standard[3];
    }else if(game){result.categories.add(gameCategories[game[1]]);palette=game[2]}
    else if(collection)palette=collection[1];
    if(!base&&(standard||game||collection)){
      result.models.add(game&&!palette?'Bench paketi':'Bench');
      for(const color of palette||'')result.colors.add(benchColors[color]);
    }
    if(base){
      if(singleBench)result.kinds.add(benchKind(result.models));
      else if(benchPack)result.kinds.add('Paket set');
      else if(base[0]===value||!base[1])result.kinds.add(base[2][0]==='1'?'Boş Bench':'Benchsiz ürün');
    }else if(singleBench)result.kinds.add('Bench');
    else if(benchPack)result.kinds.add('Bench paketi');
    else if(value==='BG-SET'){result.models.add('Set oluşturma');result.kinds.add('Set oluşturma')}
    else if(broadPack){result.models.add('Paket');result.kinds.add('Paket set')}
    // Set swatches remain the base product's colors, never the logo/Bench's colors.
    // C/BG versions and package contents cannot reliably be inferred from their codes.
    return result;
  }
  function describeVariant(sku,product,variant={}){
    const result=parseSku(sku);
    const title=normalize(product.title),type=normalize(product.type);
    // Metadata is a fallback for unknown SKU families, not a source of invented
    // Bench categories, colors or physical V1/V2 compatibility.
    if(!result.models.size){
      const patterns=[[/\bb[ -]?shirt\b|\bt[ -]?shirt\b|\btisort\b/,'B-Shirt'],[/\bdocker\b/,'Docker'],[/\btrucker\b/,'Trucker'],[/\bbeyzbol\b|\bbaseball\b/,'Beyzbol'],[/\bbucket\b/,'Bucket'],[/\bhip[ -]?hop\b/,'Hip Hop'],[/\bbere\b|\bbeanie\b/,'Bere'],[/\bsapka\b|\bcaps?\b/,'Şapka'],[/\bbench\b|\bpatch\b/,'Bench']];
      // Specific product type takes priority; a generic type still permits a specific title.
      const specificType=patterns.find(([re,label])=>!['Şapka','Bench'].includes(label)&&re.test(type));
      // Unknown SKUs may use a generic Beyzbol type. A "Vintage Logolu" design
      // is not itself evidence of the cap's model; recognized SKUs remain authoritative.
      const match=(/\bsix\b/.test(title+' '+type)?[null,'Six']:null)||(/\bvintage\b(?!\s+logolu\b)/.test(title+' '+type)?[null,'Vintage']:null)||specificType||patterns.find(([re])=>re.test(title))||patterns.find(([re])=>re.test(type));
      if(match)result.models.add(match[1]);
      else result.models.add('Diğer ürünler');
    }
    if(!result.kinds.size){
      if(/\bbench paket(?:i|leri)?\b/.test(type+' '+title))result.kinds.add('Bench paketi');
      else if(/\bbenchsiz\b/.test(type+' '+title))result.kinds.add('Benchsiz ürün');
      else if(/\bbench['’]?li\b/.test(type+' '+title))result.kinds.add(benchKind(result.models));
      else if(type==='bench'||type==='patch')result.kinds.add('Bench');
      else result.kinds.add('Diğer ürünler');
    }
    if([...result.models].some(model=>wearableModels.has(model))){
      // A Bench design/category is never an age, fabric or garment size.
      const metadata=type+' '+title;
      const confirmed=confirmedVariantFacts[String(sku||'').trim().toUpperCase()]||{};
      // Merchant confirmed: the B-Shirt range is entirely adult (2026-09-11).
      if(result.models.has('B-Shirt'))result.ages.add('Yetişkin');
      if(!result.ages.size&&confirmed.age)result.ages.add(confirmed.age);
      if(!result.ages.size){
        if(/\b(?:cocuk|kids?|children|junior)\b(?!\s+logolu\b)/.test(metadata))result.ages.add('Çocuk');
        else if(/\b(?:yetiskin|adult)\b/.test(metadata))result.ages.add('Yetişkin');
      }
      if(!result.series.size&&/\bcordura\b(?!\s+logolu\b)/.test(metadata))result.series.add('Cordura');
      if(!result.fits.size){
        if(/\boversize(?:d)?\b/.test(metadata))result.fits.add('Oversize');
        else if(result.models.has('Bere')&&/\bxl\s+bere\b/.test(title))result.fits.add('XL');
        else if(/\bregular fit\b/.test(metadata))result.fits.add('Regular');
      }
      // Prefer an explicit size option; never interpret a logo option as size.
      const names=product.optionNames||product.options||[];
      const optionName=option=>normalize(typeof option==='string'?option:option?.name).trim();
      const optionValue=(item,i)=>item.options?.[i]??item['option'+(i+1)];
      let sizeIndexes=names.flatMap((option,i)=>/^(?:beden|size|boyut)$/.test(optionName(option))?[i]:[]);
      if(!sizeIndexes.length&&result.models.has('B-Shirt')&&product.variants?.length){
        // Verified legacy shirts call their size option "Renk". Accept ONLY when
        // every variant in that column is an explicit paired size (S/M, L/XL...).
        sizeIndexes=names.flatMap((option,i)=>/^(?:renk|color|colour)$/.test(optionName(option))&&product.variants.every(item=>{
          const size=sizeValue(optionValue(item,i));return size&&/^[A-Z0-9]+-[A-Z0-9]+$/.test(size);
        })?[i]:[]);
      }
      if(sizeIndexes.length){
        sizeIndexes.forEach(i=>{const size=sizeValue(optionValue(variant,i));if(size)result.sizes.add(size)});
      }else if(result.models.has('B-Shirt')){
        // Legacy single-size products store "Oversize M-L B-Shirt" or "B-Shirt … XS-S" in their title.
        const token='(?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL)';
        const text=String(product.title||'').toUpperCase();
        const pair=text.match(new RegExp('\\b('+token+'\\s*[-/–—]\\s*'+token+')\\b'));
        const single=text.match(new RegExp('\\b(?:OVERSIZE|OVERSIZED|BEDEN|SIZE)\\s+('+token+')\\b'))||text.match(new RegExp('\\b('+token+')\\s*$'));
        const size=sizeValue(pair?.[1]||single?.[1]);if(size)result.sizes.add(size);
      }
      if(!result.sizes.size&&confirmed.size)result.sizes.add(confirmed.size);
    }
    return result;
  }
  async function pool(items, fn) {
    let cursor=0;
    await Promise.all(Array.from({length:Math.min(3,items.length)},async()=>{
      while(cursor<items.length){const item=items[cursor++];await fn(item);}
    }));
  }
  class Bbf extends HTMLElement {
    connectedCallback(){
      this.ready=()=>this.initialize();
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.ready,{once:true});
      else queueMicrotask(this.ready);
    }
    initialize(){
      if(!this.isConnected||this.initialized)return;
      this.section=this.closest('.shopify-section');
      this.container=this.section?.querySelector('#ProductGridContainer');
      this.grid=this.container?.querySelector('#product-grid');
      if(!this.grid)return;
      this.initialized=true;
      this.pageSize=Number(this.grid.dataset.bbPageSize)||50;
      this.panel=this.querySelector('.bbf-panel');
      this.toggle=this.querySelector('.bbf-toggle');
      this.container.prepend(this.panel);
      this.container.classList.add('bbf-layout');
      this.dialog=document.createElement('dialog');this.dialog.className='bbf-dialog';
      this.dialog.setAttribute('aria-labelledby',this.id+'-title');this.section.append(this.dialog);
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.open(false)});
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.open(false)});
      this.panel.querySelector('.bbf-close').onclick=()=>this.open(false);
      this.isOpen=false;
      this.toggle.onclick=()=>this.open(!this.isOpen);
      this.controls={...Object.fromEntries(Object.keys(facets).map(key=>[key,new Set()])),low:null,high:null};
      this.cards=new Map();this.pages=new Map();this.products=[];this.renderVersion=0;this.limit=this.pageSize;
      this.cacheCards(this.grid);
      this.status=document.createElement('p');this.status.className='bbf-results-status';this.status.setAttribute('role','status');
      this.more=document.createElement('button');this.more.type='button';this.more.className='bbf-more';this.more.textContent='Daha fazla göster';this.more.hidden=true;
      this.grid.after(this.status,this.more);
      this.more.onclick=()=>{this.limit+=this.pageSize;this.render()};
      this.panel.querySelector('.bbf-clear').onclick=()=>this.clear();
      this.panel.querySelector('.bbf-apply').onclick=()=>{this.commit();if(innerWidth<990)this.open(false)};
      this.panel.querySelector('.bbf-retry').onclick=()=>this.loaded?this.render():this.restart();
      this.panel.onchange=event=>{
        if(event.target.matches('[data-filter]')&&this.dataset.live!=='false')this.commit();
      };
      this.panel.querySelectorAll('input[type=range]').forEach(input=>input.oninput=event=>{
        this.syncPrice(event.target);
        if(this.dataset.live!=='false'){
          clearTimeout(this.priceTimer);
          this.priceTimer=setTimeout(()=>this.commit(),100);
        }
      });
      this.keyHandler=event=>{
        if(event.key==='Escape'&&!this.panel.hidden){event.preventDefault();this.open(false);if(innerWidth>=990)this.toggle.focus()}
        if(event.key==='Tab'&&this.dialog.open){
          const focusable=[...this.panel.querySelectorAll('button,input,select,a[href],[tabindex]')].filter(el=>!el.matches(':disabled')&&el.tabIndex>=0&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
          const first=focusable[0],last=focusable[focusable.length-1];
          if(first&&((event.shiftKey&&document.activeElement===first)||(!event.shiftKey&&document.activeElement===last))){event.preventDefault();(event.shiftKey?last:first).focus()}
        }
      };
      this.section.addEventListener('keydown',this.keyHandler);
      this.sortSelect=this.section.querySelector('select[name=sort_by]');
      const requestedSort=new URL(location.href).searchParams.get('sort_by');
      this.sortValue=requestedSort&&this.sortSelect?.querySelector('option[value="'+CSS.escape(requestedSort)+'"]')?requestedSort:(this.sortSelect?.value||'');
      this.syncSortUI();
      this.sortHandler=event=>{
        if(!event.target.matches('select[name=sort_by]'))return;
        event.stopImmediatePropagation();
        this.changeSort(event.target.value);
      };
      this.sortClickHandler=event=>{
        const button=event.target.closest('button[data-value]');
        if(!button||!button.closest('custom-select')?.contains(this.sortSelect))return;
        event.preventDefault();event.stopImmediatePropagation();
        this.changeSort(button.dataset.value);
      };
      this.sortKeyHandler=event=>{
        const trigger=event.target.closest('.js-btn-dropdown');
        if(!trigger||!trigger.closest('custom-select')?.contains(this.sortSelect)||!['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();event.stopImmediatePropagation();
        if(trigger.closest('custom-select').classList.contains('is-expanded')&&['ArrowLeft','ArrowRight'].includes(event.key))return;
        const values=[...this.sortSelect.options].filter(option=>!option.disabled).map(option=>option.value);
        const step=['ArrowDown','ArrowRight'].includes(event.key)?1:-1;
        this.changeSort(values[(values.indexOf(this.sortValue)+step+values.length)%values.length]);
      };
      this.section.addEventListener('input',this.sortHandler,true);
      this.section.addEventListener('change',this.sortHandler,true);
      this.section.addEventListener('click',this.sortClickHandler,true);
      this.section.addEventListener('keydown',this.sortKeyHandler,true);
      this.resizeHandler=()=>{
        const changed=this.mobileLayout!==(innerWidth<990);
        if(changed){clearTimeout(this.closeTimer);this.finishModal();this.container.prepend(this.panel)}
        this.updateLayout();
        if(changed){
          this.panel.hidden=!this.isOpen;
          if(this.isOpen&&innerWidth<990)this.showModal();
        }
        if(this.dialog.open)this.positionModal();
      };
      window.addEventListener('resize',this.resizeHandler);
      window.visualViewport?.addEventListener('resize',this.resizeHandler);
      this.updateLayout();
      this.restart();
    }
    disconnectedCallback(){
      document.removeEventListener('DOMContentLoaded',this.ready);
      this.controller?.abort();clearTimeout(this.priceTimer);clearTimeout(this.closeTimer);this.panelAnimation?.cancel();this.renderVersion++;
      this.section?.removeEventListener('input',this.sortHandler,true);
      this.section?.removeEventListener('change',this.sortHandler,true);
      this.section?.removeEventListener('click',this.sortClickHandler,true);
      this.section?.removeEventListener('keydown',this.sortKeyHandler,true);
      this.section?.removeEventListener('keydown',this.keyHandler);
      window.removeEventListener('resize',this.resizeHandler);
      window.visualViewport?.removeEventListener('resize',this.resizeHandler);
      this.finishModal();this.dialog?.remove();
      this.container?.classList.remove('bbf-layout','bbf-expanded');
      if(this.panel)this.append(this.panel);
      this.status?.remove();this.more?.remove();this.initialized=false;
    }
    syncSortUI(){
      const select=this.sortSelect;if(!select)return;
      const option=[...select.options].find(o=>o.value===this.sortValue);if(!option)return;
      select.value=this.sortValue;
      [...select.options].forEach(o=>{o.selected=o===option;if(o===option)o.setAttribute('selected','selected');else o.removeAttribute('selected')});
      const custom=select.closest('custom-select');if(!custom)return;
      custom.dataset.value=this.sortValue;
      custom.querySelectorAll('button[data-value]').forEach(button=>{
        const chosen=button.dataset.value===this.sortValue;button.classList.toggle('is-selected',chosen);button.setAttribute('aria-selected',String(chosen));
      });
      const trigger=custom.querySelector('.js-btn-dropdown');
      if(trigger){const icons=[...trigger.querySelectorAll('svg')].map(svg=>svg.cloneNode(true));trigger.replaceChildren(document.createTextNode(option.textContent.trim()+' '),...icons)}
      if(typeof custom.hideDropdown==='function')custom.hideDropdown();
    }
    changeSort(value){
      if(!this.sortSelect||![...this.sortSelect.options].some(o=>o.value===value))return;
      const changed=this.sortValue!==value;this.sortValue=value;this.syncSortUI();
      if(!changed)return;
      if(this.loaded)this.readControls();
      clearTimeout(this.priceTimer);
      const url=new URL(location.href);url.searchParams.set('sort_by',value);url.searchParams.delete('page');
      history.replaceState(history.state,'',url);
      this.restart();
    }
    updateLayout(){
      this.mobileLayout=innerWidth<990;
      this.panel.querySelector('.bbf-apply').textContent=this.mobileLayout?'Uygula':'Ürünleri göster';
    }
    positionModal(){
      const headers=[...document.querySelectorAll('.section-header, .header-wrapper, sticky-header, header')];
      const bottom=headers.reduce((max,node)=>{const r=node.getBoundingClientRect();return r.top<innerHeight&&r.bottom>0?Math.max(max,r.bottom):max},0);
      // Keep the actual header plus a small strip of the page visible.
      const viewportHeight=window.visualViewport?.height||innerHeight;
      const top=Math.min(viewportHeight*.4,Math.max(80,viewportHeight*.15,bottom+24));
      this.dialog.style.setProperty('--bb-modal-height',(viewportHeight-top)+'px');
    }
    showModal(){
      if(Bbf.activeModal&&Bbf.activeModal!==this){Bbf.activeModal.open(false);Bbf.activeModal.finishModal()}
      Bbf.activeModal=this;
      this.dialog.append(this.panel);this.positionModal();
      if(!this.dialog.open){
        const root=document.documentElement;
        this.scrollStyles={overflow:root.style.getPropertyValue('overflow'),overflowPriority:root.style.getPropertyPriority('overflow'),gutter:root.style.getPropertyValue('scrollbar-gutter'),gutterPriority:root.style.getPropertyPriority('scrollbar-gutter')};
        if(innerWidth>root.clientWidth)root.style.setProperty('scrollbar-gutter','stable');
        root.style.setProperty('overflow','hidden');
        this.dialog.showModal();
      }
      void this.dialog.offsetHeight;this.dialog.classList.add('is-open');
    }
    finishModal(){
      if(this.dialog?.open)this.dialog.close();
      this.dialog?.classList.remove('is-open');
      if(this.scrollStyles){
        const root=document.documentElement,saved=this.scrollStyles;
        for(const [property,value,priority] of [['overflow',saved.overflow,saved.overflowPriority],['scrollbar-gutter',saved.gutter,saved.gutterPriority]]){
          if(value)root.style.setProperty(property,value,priority);else root.style.removeProperty(property);
        }
        this.scrollStyles=null;
      }
      if(Bbf.activeModal===this)Bbf.activeModal=null;
    }
    open(value){
      this.updateLayout();
      this.isOpen=value;clearTimeout(this.closeTimer);this.panelAnimation?.cancel();
      this.panel.hidden=false;this.panel.inert=!value;
      this.panel.setAttribute('aria-hidden',String(!value));
      this.toggle.setAttribute('aria-expanded',String(value));
      // Flush the collapsed layout before switching the CSS transition target.
      void this.container.offsetWidth;
      this.container.classList.toggle('bbf-expanded',value);
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration=reduced?0:320;
      if(innerWidth<990){
        if(value)this.showModal();
        else{
          this.dialog.classList.remove('is-open');
          const finish=()=>{if(!this.isOpen){this.panel.hidden=true;this.finishModal()}};
          if(duration)this.closeTimer=setTimeout(finish,duration);else finish();
        }
        return;
      }
      if(!value){
        if(!duration)this.panel.hidden=true;
        else this.closeTimer=setTimeout(()=>{if(!this.isOpen)this.panel.hidden=true},duration);
      }
    }
    async request(sectionId,page,signal){
      const url=new URL(this.baseUrl);
      url.searchParams.set('section_id',sectionId);url.searchParams.set('page',page);
      const requestSignal=typeof AbortSignal.any==='function'?AbortSignal.any([signal,AbortSignal.timeout(20000)]):signal;
      const response=await fetch(url,{signal:requestSignal,credentials:'same-origin',headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('HTTP '+response.status);
      return new DOMParser().parseFromString(await response.text(),'text/html');
    }
    readIndex(doc,page){
      const node=doc.querySelector('[data-bb-index]');
      if(!node)throw new Error('BB koleksiyon veri dosyası bulunamadı.');
      const data=JSON.parse(node.textContent);
      if(!Array.isArray(data.products)||Number(data.page)!==page||!Number.isFinite(Number(data.total)))throw new Error('Koleksiyon verisi okunamadı.');
      return data;
    }
    setLoading(value){
      this.panel.querySelectorAll('fieldset').forEach(el=>el.disabled=value);
      this.panel.querySelector('.bbf-apply').disabled=value;
      this.panel.querySelector('.bbf-clear').disabled=value;
      this.more.disabled=value;
    }
    async restart(){
      this.controller?.abort();this.controller=new AbortController();
      const signal=this.controller.signal;this.renderVersion++;this.pages=new Map();this.limit=this.pageSize;this.loaded=false;
      this.baseUrl=new URL(location.href);
      for(const key of [...this.baseUrl.searchParams.keys()]){
        if(['page','section_id','sections'].includes(key)||key.startsWith('filter.'))this.baseUrl.searchParams.delete(key);
      }
      // Shopify's native order is the source order for both the index and cards.
      // The custom review sort is applied locally AFTER filtering; never send it
      // as an unsupported sort_by value to Shopify. Source positions stay intact.
      if(this.sortValue)this.baseUrl.searchParams.set('sort_by',this.sortValue==='most-reviewed'?'best-selling':this.sortValue);
      this.setLoading(true);this.more.hidden=true;
      this.panel.querySelector('.bbf-retry').hidden=true;
      const progress=this.panel.querySelector('.bbf-status');progress.hidden=false;progress.textContent='Filtreler hazırlanıyor…';
      try{
        const first=this.readIndex(await this.request(this.dataset.indexSection,1,signal),1);
        const batches=[first];
        await pool(Array.from({length:Math.max(0,first.pages-1)},(_,i)=>i+2),async page=>{
          const data=this.readIndex(await this.request(this.dataset.indexSection,page,signal),page);
          batches[page-1]=data;
        });
        if(signal.aborted||!this.isConnected)return;
        const all=batches.flatMap(batch=>batch.products).map(product=>({...product,handle:productKey(product.handle)}));
        if(all.length!==first.total||new Set(all.map(p=>p.handle)).size!==all.length)throw new Error('Koleksiyon taraması tamamlanamadı.');
        this.products=all.map((product,position)=>({...product,position,variants:product.variants.map(v=>({...describeVariant(v.sku,product,v),price:Number(v.price)}))}));
        if(this.products.some(p=>typeof p.soldOut!=='boolean'))throw new Error('Tükenenleri sona almak için bb-sku-index.liquid dosyasını güncelleyin.');
        if(this.sortValue==='most-reviewed'&&this.products.some(p=>!Number.isFinite(Number(p.reviewCount))||p.reviewCount===null||p.reviewCount===undefined))throw new Error('Değerlendirme verisi için bb-sku-index.liquid dosyasını güncelleyin.');
        this.loaded=true;this.setLoading(false);this.drawOptions();this.priceBounds();
        progress.textContent='';progress.hidden=true;
        this.readControls();this.refreshFacets();this.readControls();
        await this.render();
      }catch(error){
        if(signal.aborted)return;
        this.status.textContent='Filtre verileri yüklenemedi. Yeniden dene düğmesiyle tekrar deneyebilirsiniz.';
        progress.hidden=false;progress.textContent=error.message.includes('bb-sku-index.liquid')?error.message:'Filtreler yüklenemedi. Lütfen yeniden deneyin.';
        this.panel.querySelector('.bbf-retry').hidden=false;
      }
    }
    cacheCards(root){
      for(const card of root.querySelectorAll('product-card')){
        const link=card.querySelector('a[href*="/products/"]');
        const rawHandle=link?.getAttribute('href').match(/\/products\/([^/?#]+)/)?.[1];
        const handle=rawHandle?productKey(rawHandle):null;
        card.style.removeProperty('order');
        if(handle&&!this.cards.has(handle))this.cards.set(handle,card);
      }
    }
    drawOptions(){
      for(const [type,key] of Object.entries(facets)){
        const values=new Set();this.products.forEach(p=>p.variants.forEach(v=>v[key].forEach(value=>values.add(value))));
        this.draw(type,[...values].sort((a,b)=>compareOptions(type,a,b)));
      }
    }
    refreshFacets(){
      for(const [type,key] of Object.entries(facets)){
        // OR within a group, AND across groups, always on the same variant.
        // Ignore this group's selection to keep alternative choices available.
        const options=new Set(this.controls[type]);
        this.products.forEach(p=>p.variants.forEach(v=>{
          if(this.matchesVariant(v,type))v[key].forEach(value=>options.add(value));
        }));
        const values=[...options].sort((a,b)=>compareOptions(type,a,b));
        const existing=[...this.panel.querySelectorAll('[data-filter='+type+']')].map(input=>input.value);
        if(JSON.stringify(values)!==JSON.stringify(existing))this.draw(type,values);
      }
    }
    draw(type,values){
      const host=this.panel.querySelector('[data-'+facets[type]+']');if(!host)return;host.replaceChildren();
      const kept=new Set(values.filter(value=>this.controls[type].has(value)));this.controls[type]=kept;
      values.forEach((value,index)=>{
        const wrap=document.createElement('span'),input=document.createElement('input'),label=document.createElement('label');
        wrap.className='bbf-option bbf-option--'+type;input.type='checkbox';input.id=this.id+'-'+type+'-'+index;
        input.value=value;input.dataset.filter=type;input.checked=kept.has(value);label.htmlFor=input.id;
        if(type==='color'){
          label.title=colors[value][0];label.setAttribute('aria-label',colors[value][0]);
          const swatch=document.createElement('span');swatch.className='bbf-swatch';swatch.style.setProperty('--color',colors[value][1]);label.append(swatch);
        }else label.textContent=value;
        wrap.append(input,label);host.append(wrap);
      });
      this.panel.querySelector('[data-group='+type+']').hidden=!values.length;
    }
    money(value){return Number(value).toLocaleString('tr-TR',{maximumFractionDigits:2})+' TL'}
    priceBounds(){
      const a=this.panel.querySelector('[data-min]'),b=this.panel.querySelector('[data-max]');if(!a||!b)return;
      const prices=this.products.flatMap(p=>p.variants.map(v=>v.price)).filter(Number.isFinite);
      this.floor=prices.length?Math.min(...prices)/100:0;this.ceiling=prices.length?Math.max(...prices)/100:0;
      a.min=b.min=this.floor;a.max=b.max=this.ceiling;a.step=b.step='0.01';
      a.disabled=b.disabled=this.floor===this.ceiling;
      a.value=this.controls.low===null?this.floor:Math.min(this.ceiling,Math.max(this.floor,this.controls.low));
      b.value=this.controls.high===null?this.ceiling:Math.max(this.floor,Math.min(this.ceiling,this.controls.high));
      this.panel.querySelector('[data-floor]').textContent=this.money(this.floor);this.panel.querySelector('[data-ceiling]').textContent=this.money(this.ceiling);this.syncPrice();
    }
    syncPrice(changed){
      const a=this.panel.querySelector('[data-min]'),b=this.panel.querySelector('[data-max]');if(!a||!b)return;
      if(+a.value>+b.value){if(changed===a)a.value=b.value;else b.value=a.value}
      const span=this.ceiling-this.floor||1,r=this.panel.querySelector('[data-range]');
      r.style.setProperty('--start',((+a.value-this.floor)/span*100)+'%');r.style.setProperty('--end',((+b.value-this.floor)/span*100)+'%');
      this.panel.querySelector('[data-min-label]').textContent=this.money(a.value);this.panel.querySelector('[data-max-label]').textContent=this.money(b.value);
    }
    readControls(){
      for(const type of Object.keys(facets))this.controls[type]=new Set([...this.panel.querySelectorAll('[data-filter='+type+']:checked')].map(i=>i.value));
      const a=this.panel.querySelector('[data-min]'),b=this.panel.querySelector('[data-max]');
      this.controls.low=a&&+a.value>this.floor?+a.value:null;this.controls.high=b&&+b.value<this.ceiling?+b.value:null;
      const count=Object.keys(facets).reduce((n,type)=>n+this.controls[type].size,0)+(this.controls.low!==null||this.controls.high!==null?1:0);
      const badge=this.querySelector('.bbf-count');badge.dataset.count=count;badge.classList.toggle('is-visible',count>0);
    }
    commit(){if(!this.loaded)return;this.readControls();this.refreshFacets();this.readControls();this.limit=this.pageSize;this.render()}
    clear(){
      this.panel.querySelectorAll('input[type=checkbox]').forEach(i=>i.checked=false);
      this.controls.low=this.controls.high=null;this.priceBounds();this.commit();
    }
    matches(product){
      return product.variants.some(v=>this.matchesVariant(v));
    }
    matchesVariant(variant,ignore){
      const {low,high}=this.controls;
      return Object.entries(facets).every(([type,key])=>type===ignore||!this.controls[type].size||[...this.controls[type]].some(value=>variant[key].has(value)))&&
        (low===null||variant.price>=Math.round(low*100))&&(high===null||variant.price<=Math.round(high*100));
    }
    async ensureCardPage(page,signal){
      const pages=this.pages;
      if(!pages.has(page)){
        const task=this.request(this.dataset.section,page,signal).then(doc=>{
          const grid=doc.querySelector('#product-grid');
          if(!grid)throw new Error('Ürün kartları alınamadı.');
          this.cacheCards(grid);
        }).catch(error=>{pages.delete(page);throw error});
        pages.set(page,task);
      }
      await pages.get(page);
    }
    async render(){
      if(!this.loaded)return;
      const version=++this.renderVersion,signal=this.controller.signal;
      const matched=this.products.filter(p=>this.matches(p));
      // Partition the ENTIRE matching collection before taking a page. Keep the
      // selected order inside both groups and the original card-fetch positions.
      matched.sort((a,b)=>Number(a.soldOut)-Number(b.soldOut)||(this.sortValue==='most-reviewed'?Number(b.reviewCount)-Number(a.reviewCount):0)||a.position-b.position);
      const visible=matched.slice(0,this.limit);
      const handles=new Set(visible.map(p=>p.handle));
      // Hide immediately with a scoped !important rule while missing native cards load.
      for(const card of this.grid.querySelectorAll('product-card')){
        const link=card.querySelector('a[href*="/products/"]');
        const rawHandle=link?.getAttribute('href').match(/\/products\/([^/?#]+)/)?.[1];
        const handle=rawHandle?productKey(rawHandle):null;
        card.classList.toggle('bbf-excluded',!handles.has(handle));
      }
      this.status.textContent='Eşleşen '+matched.length+' ürün hazırlanıyor…';this.more.disabled=true;
      this.panel.querySelector('.bbf-retry').hidden=true;
      this.panel.querySelector('.bbf-status').hidden=true;
      this.grid.setAttribute('aria-busy','true');
      try{
        const needed=[...new Set(visible.filter(p=>!this.cards.has(p.handle)).map(p=>Math.floor(p.position/this.pageSize)+1))];
        await pool(needed,page=>this.ensureCardPage(page,signal));
        if(version!==this.renderVersion||signal.aborted||!this.isConnected)return;
        if(visible.some(p=>!this.cards.has(p.handle)))throw new Error('Ürün listesi değişti; koleksiyonu yeniden tarayın.');
        const nodes=visible.map(p=>this.cards.get(p.handle));
        nodes.forEach(node=>{node.style.removeProperty('order');node.classList.remove('bbf-excluded','scroll-trigger');node.hidden=false;node.classList.add('scroll-trigger--cancel')});
        this.grid.replaceChildren(...nodes);
        this.status.textContent=matched.length?matched.length+' eşleşen ürün · '+visible.length+' ürün gösteriliyor.':'Bu seçimlere uygun ürün bulunamadı.';
        const count=this.section.querySelector('#ProductCount');if(count)count.textContent=visible.length+' / '+matched.length+' ürün';
        this.more.hidden=visible.length>=matched.length;this.more.disabled=false;this.grid.setAttribute('aria-busy','false');
        this.panel.querySelector('.bbf-retry').hidden=true;
      }catch(error){
        if(version!==this.renderVersion||signal.aborted)return;
        this.status.textContent='Ürünler yüklenemedi. '+error.message;
        const progress=this.panel.querySelector('.bbf-status');progress.hidden=false;progress.textContent='Bazı ürünler yüklenemedi. Lütfen yeniden deneyin.';
        this.panel.querySelector('.bbf-retry').hidden=false;
        this.more.disabled=false;this.grid.setAttribute('aria-busy','false');
      }
    }
  }
  customElements.define('bb-sku-filter',Bbf);
})();
